var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMiniIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99385 4.29248L7.55549 1.72955C7.85915 1.42574 7.85915 0.934968 7.55549 0.631157C7.25183 0.327345 6.7613 0.327345 6.45764 0.631157L3.896 3.19408L1.33436 0.623367C1.0307 0.319555 0.540168 0.319555 0.236508 0.623367C-0.0671523 0.927178 -0.0671523 1.41795 0.236508 1.72176L2.79815 4.29248L0.228722 6.8554C-0.0749384 7.15921 -0.0749384 7.64999 0.228722 7.9538C0.384445 8.1096 0.579098 8.1875 0.781538 8.1875C0.983978 8.1875 1.17863 8.1096 1.33436 7.96159L3.896 5.39087L6.45764 7.9538C6.61337 8.1096 6.80802 8.1875 7.01046 8.1875C7.2129 8.1875 7.40755 8.1096 7.56328 7.96159C7.86694 7.65778 7.86694 7.167 7.56328 6.86319L4.99385 4.29248Z",
    fill: "#5F6567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMiniIcon);
export default __webpack_public_path__ + "static/media/close-mini-icon.5d42e274423a9562de5546df999b5b61.svg";
export { ForwardRef as ReactComponent };